<template>
    <div class="input-component">
        <div class="label" v-if="label">
            {{label === '_' ? '\u00A0' : label}}
        </div>
        <div class="skeleton" :class="{'match': valuesMatch, 'no-match': !valuesMatch}">
            <div class="saturn" :class="{'invalid': invalid}" @click="toggleShowError(null, $event)" @mouseover="toggleShowError(true, $event)" @mouseleave="toggleShowError(false, $event)">
                <div class="saturn-textbox">

                    <select v-model="vm.saturn" :disabled="disabled">

                        <!--IF WE ARE WORKING WITH OBJECTS, CHECK FOR NULL..... ELSE - CHECK IF BLANK-->
                        <option :value="blankValue" v-if="nothingSelected && !vm.value">{{nothingSelected}}</option>
                        <option :value="nullValue" v-else-if="nothingSelected && vm.value">{{nothingSelected}}</option>

                        <option v-for="item in vm.list" v-bind:key="itemText(item)" :value="itemValue(item)" :disabled="itemIsDisabled(item)">
                            <div v-if="unicodeIcon" v-html="itemUnicodeIcon(item)+'&#10240;'"></div>{{itemText(item)}}
                        </option>
                    </select>

                    <div class="saturn-textbox-error-message" v-if="errorHover && invalid">
                        <div v-if="hasValidationSlot">
                            <slot name="validation"></slot>
                        </div>
                        <div v-else>
                            Invalid Input
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "InputDropdown",
        props: ['saturn', 'cdk', 'label', 'unicodeIcon', 'invalid', 'disabled', 'list', 'text', 'value', 'comparer', 'copy', 'cdkText', 'nothingSelected', 'itemDisabled'],
        data() {
            return {
                vm: {
                    saturn: null,
                    cdk: null,
                    list: null,
                    text: null,
                    value: null,
                    copy: null,
                    disabled: null
                },
                errorHover: false,
                nullValue: null,
                blankValue: ''
            };
        },
        computed: {
            valuesMatch() {

                if (this.vm.cdk && this.vm.saturn) {
                    if (this.comparer)
                        return this.comparer(this.vm.saturn, this.vm.cdk);
                    else if (this.isFunction(this.vm.value))
                        return this.vm.value(this.vm.saturn) === this.vm.cdk
                    else
                        return this.vm.saturn === this.vm.cdk;
                }
                else
                    return false;

            },
            hasValidationSlot() {
                return !!this.$slots['validation']
            }
        },
        created() {
            this.init();
            
            this.$watch(() => this.$props, function (newValue) {
                this.init();
            }, { deep: true, immediate: true });

            this.$watch(() => this.vm.saturn, function (newValue) {
                this.$emit('change');
            }, { deep: true });

            //@change="$emit('change')"

        },
        methods: {
            copyValueFromCDK() {
                if (this.copy)
                    this.vm.saturn = this.copy(this.vm.cdk, this.vm.list);
                else
                    this.vm.saturn = this.vm.cdk;
            },
            init() {
                this.vm.saturn = this.saturn;
                this.vm.cdk = this.cdk;
                this.vm.list = this.list;
                this.vm.unicodeIcon = this.unicodeIcon;
                this.vm.text = this.text;
                this.vm.value = this.value;
                this.vm.cdkText = this.cdkText ? this.cdkText : this.cdk;
                this.vm.disabled = this.itemDisabled;
            },
            itemUnicodeIcon(item) {
                return this.isFunction(this.vm.unicodeIcon) ? this.vm.unicodeIcon(item) : (this.isPrimitive(item) ? item : item[this.vm.unicodeIcon]);
            },
            itemText(item) {
                if (this.isFunction(this.vm.text)) {
                    return this.vm.text(item);
                }
                else if (this.isPrimitive(item)) {
                    return item;
                }
                else {
                    return item[this.vm.text];
                }
            },
            itemValue(item) {
                if (this.isFunction(this.vm.value)) {
                    return this.vm.value(item);
                }
                else if (this.isPrimitive(item)) {
                    return item;
                }
                else { 
                    return item[this.vm.value];
                }
            },
            itemIsDisabled(item) {
                return this.isFunction(this.vm.disabled) ? this.vm.disabled(item) : item.disabled;
            },
            toggleShowError(override, event) {
                if (!this.invalid) return;

                let isMobile = window.matchMedia('(max-width: 600px)').matches;

                if (event.type === 'click') {
                    this.errorHover = !this.errorHover
                }
                else if (!isMobile) {
                    this.errorHover = override;
                }
            },
            isFunction(functionToCheck) {
                return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
            },
            isPrimitive(test) {
                return (test !== Object(test));
            }
        },
        components: {

        }
    };

</script>


